import { Injectable, OnDestroy, inject } from '@angular/core';
import { ClipboardService, IClipboardResponse } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClipboardResponseService implements OnDestroy {
  public _clipboardService = inject(ClipboardService);
  private _toasterService = inject(ToastrService);

  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    this.handleClipboardResponse();
  }

  private handleClipboardResponse(): void {
    this._clipboardService.copyResponse$.pipe(takeUntil(this.destroyed$)).subscribe((res: IClipboardResponse) => {
      if (res.isSuccess) {
        this._toasterService.success('Copied to clipboard', 'Success');
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
